import { render, staticRenderFns } from "./CaseImport.vue?vue&type=template&id=68012702&"
import script from "./CaseImport.vue?vue&type=script&lang=js&"
export * from "./CaseImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports